export default function assetUrl(url, apiUrl) {
  const path = url || ''
  if (!path.startsWith('/rails/')) return path
  return `${String(apiUrl || '').replace(/\/$/, '')}${path}`
}
